import { ContractInfo } from 'api/types/httpsTypes/contracts';
import { OwnerInfo } from './ownerInfo';
import { TradingInfo } from './tradingInfo';
import { MethodsInfo } from './methodsInfo';

interface Props {
  contract: ContractInfo;
}

export const TradeStats = ({ contract }: Props) => {
  return (
    <div className="xxs:p-2 overflow-y-scroll my-0 ">
      <div className="flex flex-col w-full lg:w-full h-full xxs:gap-0 lg:gap-1 ">
        <div className="flex flex-col lg:flex-row w-full xxs:gap-0 lg:gap-1 h-full ">
          <TradingInfo contract={contract} />
          <OwnerInfo contract={contract} />
        </div>
        <MethodsInfo contract={contract} />
      </div>
    </div>
  );
};
